var $662ccaf2be4c25b3$exports = {};
$662ccaf2be4c25b3$exports = {
  "dismiss": "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
};
export { $662ccaf2be4c25b3$exports as default };